module.exports = __webpack_public_path__ + "static/media/portfolio1 (62).16d1e905.jpeg";